var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M473.654,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621 c0-21.177,17.167-38.345,38.345-38.345h435.309c21.177,0,38.345,17.167,38.345,38.345v258.758 C511.999,406.557,494.831,423.724,473.654,423.724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 282.481,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 23.54
  }), /*#__PURE__*/React.createElement("rect", {
    y: 329.571,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 23.54
  })), /*#__PURE__*/React.createElement("rect", {
    y: 306.021,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 23.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M169.649,234.664l2.708,8.118l8.557,0.066c0.663,0.006,0.938,0.851,0.405,1.245l-6.884,5.084 l2.581,8.159c0.2,0.632-0.52,1.155-1.059,0.769l-6.963-4.977l-6.963,4.977c-0.54,0.385-1.259-0.137-1.059-0.769l2.581-8.159 l-6.884-5.084c-0.533-0.394-0.258-1.24,0.405-1.245l8.557-0.066l2.708-8.118C168.549,234.035,169.44,234.035,169.649,234.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M169.649,377.322l2.708,8.118l8.557,0.066c0.663,0.006,0.938,0.851,0.405,1.245l-6.884,5.084 l2.581,8.159c0.2,0.632-0.52,1.155-1.059,0.769l-6.963-4.977l-6.963,4.977c-0.54,0.385-1.259-0.137-1.059-0.769l2.581-8.159 l-6.884-5.084c-0.533-0.394-0.258-1.24,0.405-1.245l8.557-0.066l2.708-8.118C168.549,376.693,169.44,376.693,169.649,377.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M123.342,385.293l6.881-5.088l7.041,4.864c0.545,0.376,1.257-0.158,1.047-0.787l-2.712-8.117 l6.802-5.194c0.527-0.403,0.238-1.244-0.425-1.238l-8.557,0.071l-2.838-8.074c-0.22-0.626-1.109-0.611-1.309,0.021l-2.577,8.161 l-8.555,0.204c-0.663,0.015-0.924,0.866-0.384,1.251l6.965,4.972l-2.45,8.2C122.081,385.176,122.808,385.687,123.342,385.293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M137.104,269.322l-6.987-4.941l-6.937,5.012c-0.537,0.388-1.26-0.131-1.063-0.765l2.54-8.172 l-6.91-5.049c-0.535-0.391-0.265-1.238,0.398-1.247l8.557-0.109l2.667-8.131c0.206-0.63,1.096-0.634,1.309-0.007l2.749,8.105 l8.558,0.023c0.663,0.002,0.942,0.846,0.41,1.242l-6.859,5.118l2.623,8.147C138.363,269.178,137.646,269.704,137.104,269.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M201.552,269.427l6.881-5.088l7.041,4.864c0.545,0.376,1.257-0.158,1.047-0.787l-2.712-8.117 l6.802-5.194c0.527-0.403,0.238-1.244-0.425-1.238l-8.557,0.071l-2.838-8.074c-0.22-0.626-1.109-0.611-1.309,0.021l-2.577,8.161 l-8.555,0.204c-0.663,0.015-0.924,0.866-0.384,1.251l6.965,4.972l-2.45,8.2C200.291,269.309,201.019,269.821,201.552,269.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M215.315,385.189l-6.987-4.941l-6.937,5.012c-0.537,0.388-1.26-0.131-1.063-0.765l2.54-8.172 l-6.91-5.049c-0.535-0.391-0.265-1.238,0.398-1.247l8.557-0.109l2.667-8.131c0.206-0.63,1.096-0.634,1.309-0.007l2.749,8.105 l8.558,0.023c0.663,0.002,0.942,0.846,0.41,1.242l-6.859,5.118l2.623,8.147C216.573,385.045,215.856,385.571,215.315,385.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M113.107,335.327l-8.557,0.056l-2.824-8.078c-0.218-0.626-1.108-0.613-1.309,0.019l-2.591,8.157 l-8.556,0.19c-0.663,0.014-0.926,0.865-0.386,1.251l6.957,4.984l-2.464,8.195c-0.191,0.634,0.536,1.148,1.07,0.754l6.89-5.076 l7.033,4.876c0.545,0.377,1.257-0.156,1.048-0.785l-2.699-8.121l6.81-5.182C114.057,336.165,113.77,335.323,113.107,335.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M89.271,291.343l8.556-0.161l2.617-8.148c0.203-0.631,1.092-0.641,1.309-0.014l2.798,8.087 l8.558-0.029c0.663-0.002,0.948,0.841,0.418,1.24l-6.827,5.16l2.673,8.13c0.207,0.63-0.506,1.161-1.05,0.781l-7.017-4.898 l-6.906,5.054c-0.535,0.392-1.26-0.124-1.068-0.758l2.49-8.188l-6.941-5.006C88.343,292.204,88.609,291.355,89.271,291.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M248.699,291.027l-8.557,0.056l-2.824-8.078c-0.218-0.626-1.108-0.613-1.309,0.019l-2.591,8.157 l-8.556,0.19c-0.663,0.014-0.926,0.865-0.386,1.251l6.957,4.984l-2.464,8.195c-0.191,0.635,0.536,1.148,1.07,0.755l6.89-5.076 l7.033,4.876c0.545,0.377,1.257-0.156,1.048-0.785l-2.698-8.121l6.81-5.182C249.649,291.865,249.362,291.023,248.699,291.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M224.864,335.643l8.556-0.161l2.617-8.148c0.203-0.631,1.092-0.641,1.309-0.014l2.798,8.087 l8.558-0.029c0.663-0.002,0.948,0.841,0.418,1.24l-6.827,5.16l2.673,8.13c0.207,0.63-0.506,1.161-1.05,0.781l-7.017-4.898 l-6.906,5.054c-0.535,0.392-1.26-0.124-1.068-0.758l2.49-8.188l-6.941-5.006C223.936,336.505,224.201,335.656,224.864,335.643z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.b5cf938457438d3debd7d74ffa1b26d5.svg";
export { ForwardRef as ReactComponent };